export const DICT = 'Dict';
//# sourceMappingURL=DICT.js.map